import React from 'react';

/** Фирменный цвет кнопок/обводок MAX (середина градиента логотипа). */
export const MAX_COLOR = '#5B5CFF';

interface MaxIconProps {
  /** Размер плитки: `sm` — 36px (селектор), `md` — 40px (заголовки, связывание). */
  size?: 'sm' | 'md';
  className?: string;
}

/** Плитка с логотипом мессенджера MAX: облачко-реплика на сине-фиолетовом градиенте. */
const MaxIcon: React.FC<MaxIconProps> = ({ size = 'md', className = '' }) => {
  const box = size === 'sm' ? 'w-9 h-9 rounded-lg' : 'w-10 h-10 rounded-xl';
  return (
    <div
      className={`${box} flex flex-shrink-0 justify-center items-center bg-gradient-to-br from-[#3D8BFF] to-[#8A3DFF] ${className}`}
    >
      <svg className="w-5 h-5 text-on-accent" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 2.5c-5.24 0-9.5 3.94-9.5 8.8 0 2.62 1.24 4.97 3.2 6.58-.12 1.2-.6 2.4-1.5 3.42 2.02.07 3.74-.67 4.95-1.6.92.25 1.88.39 2.85.39 5.24 0 9.5-3.94 9.5-8.8S17.24 2.5 12 2.5Zm-3.9 11.4V8.4h1.5l2.4 3.05 2.4-3.05h1.5v5.5h-1.6v-3.2l-2.3 2.9-2.3-2.9v3.2H8.1Z" />
      </svg>
    </div>
  );
};

export default MaxIcon;
